export enum DocType {
    invoice = 'invoice',
    shippingLabel = 'shippingLabel',
    carrierManifest = 'carrierManifest',
}
